// Het teken van Marvin (tekstballon met twee ogen), zonder React: ook bruikbaar in de service en in e-mail/InServe-HTML.
// De React-versie staat in components/MarvinTeken.tsx.
export const BALLON = 'M4.5 7a2.8 2.8 0 0 1 2.8-2.8h9.4A2.8 2.8 0 0 1 19.5 7v6.6a2.8 2.8 0 0 1-2.8 2.8h-5.4l-4.1 3.4v-3.4h-.4a2.8 2.8 0 0 1-2.3-2.8z'
export const OGEN: [number, number][] = [[9.4, 10.4], [14.6, 10.4]]
export const MINT = '#46F0A4'
export const INKT = '#171717'

export function marvinTekenSvg(size: number, kleur = INKT, dikte = 2.2): string {
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="${kleur}" stroke-width="${dikte}" stroke-linecap="round" stroke-linejoin="round"><path d="${BALLON}"/>${OGEN.map(([x, y]) => `<circle cx="${x}" cy="${y}" r="1.35" fill="${kleur}" stroke="none"/>`).join('')}</svg>`
}
